import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MicroFE } from '@ntet/fos-micro-fe';

const MicroFEApp = React.memo(({ context, config }) => {
  const { applications } = config;

  useEffect(() => {
    const microFE = new MicroFE(context);
    const { history } = microFE.context;
    const unlisten = history.listen((location) =>
      microFE.startAtRoute(location)
    );

    microFE
      .registerApps(config)
      .then((mfe) => {
        mfe.start();
      })
      .catch((err) => console.log(err));

    return () => {
      unlisten();
    };
  }, [config, context]);

  return (
    <>
      {applications.map(({ name }) => (
        <main key={name} id={name} className="micro-app-container" />
      ))}
    </>
  );
});

MicroFEApp.propTypes = {
  context: PropTypes.shape().isRequired,
  config: PropTypes.shape().isRequired,
};

export default MicroFEApp;
